import { AppStore } from '../store';

export function selectTampon(store: AppStore) {
  return store.tampon;
}
